import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  authorization : ''
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
  setToken(state, token){
    let new_token = 'Bearer ' + token
    localStorage.setItem('auth_token', new_token, 8400)
    state.authorization = new_token
    Vue.prototype.$http.defaults.headers.common["Authorization"] = new_token
  },
  removeToken(){
    localStorage.removeItem('auth_token')
  },
}

export default new Vuex.Store({
  state,
  mutations
})